import type { PropCategory } from "@circle-react-shared/BuilderUI/DataModel.types";
import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";
import { DesignProp } from "@circle-react-shared/BuilderUI/constants/PropCategories";

export const getBackgroundColorOptions = ({
  defaultValue = "#ffffff",
  category = [DesignProp],
}: {
  defaultValue?: string;
  category?: PropCategory[];
}): StyleValue => ({
  type: "color",
  value: defaultValue,
  meta: {
    name: "Background Color",
    nameI18n: "builder_ui.prop_type.styles.background_color",
    category,
  },
});

export const getBorderColorOptions = ({
  defaultValue = "#000000",
  category = [DesignProp],
}: {
  defaultValue?: string;
  category?: PropCategory[];
}): StyleValue => ({
  type: "color",
  value: defaultValue,
  meta: {
    name: "Border Color",
    nameI18n: "builder_ui.prop_type.styles.border_color",
    category,
  },
});

export const getBorderWidthOptions = ({
  defaultValue = "1",
  category = [DesignProp],
}: {
  defaultValue?: string;
  category?: PropCategory[];
}): StyleValue => ({
  type: "slider",
  value: defaultValue,
  meta: {
    name: "Border Width",
    nameI18n: "builder_ui.prop_type.styles.border_width",
    category,
    unit: "px",
    sliderProps: {
      units: ["px", "rem"],
      step: 1,
      min: 0,
      max: 100,
    },
  },
});

export const getBorderRadiusOptions = ({
  defaultValue = {
    border_left_top_radius: "4",
    border_left_bottom_radius: "4",
    border_right_top_radius: "4",
    border_right_bottom_radius: "4",
  },
  category = [DesignProp],
}: {
  defaultValue?: {
    border_left_top_radius: string;
    border_left_bottom_radius: string;
    border_right_top_radius: string;
    border_right_bottom_radius: string;
  };
  category?: PropCategory[];
}): StyleValue => ({
  type: "border-radius",
  value: {
    border_left_top_radius: defaultValue.border_left_top_radius,
    border_left_bottom_radius: defaultValue.border_left_bottom_radius,
    border_right_top_radius: defaultValue.border_right_top_radius,
    border_right_bottom_radius: defaultValue.border_right_bottom_radius,
  },
  meta: {
    name: "Corner Radius",
    nameI18n: "builder_ui.prop_type.styles.corner_radius",
    unit: "px",
    category,
  },
});
